import React from 'react';
import Glyph from '@uds/glyphs';

import { useListItemStyles as useStylesheet } from './stylesheets';
import { RecursiveShortcodeProps } from './Shortcode';

const TickListItem = ({
  RecursiveShortcode,
  elements,
  glyph,
  against,
  attributes,
  layout,
  ...rest
}: RecursiveShortcodeProps) => {
  const { styles } = useStylesheet({
    against,
    attributes,
    layout,
  });
  return (
    <li style={styles.root}>
      <span style={styles.wrapper}>
        <span style={styles.icon}>
          <Glyph name={glyph} size={styles.icon.width as number} color={styles.icon.color as string} />
        </span>
        <span style={styles.text}>
          {/*  @ts-ignore: error when upgrading to @ux/config */}
          <RecursiveShortcode elements={elements} {...rest} />
        </span>
      </span>
    </li>
  );
};

TickListItem.displayName = 'TickListItem';

export default TickListItem;
